export default __webpack_public_path__ + "static/media/featRaceBg.a7177017.png";